/**
 * @fileoverview POST handler for the "/apps/business/accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessAccountsCacheKeys } from "./constants";
import type { PostAppsBusinessAccountsProps, AppsBusinessAccountsResult } from "./types";

export const postAppsBusinessAccounts = reactQueryMutationAdapter(
  appsBusinessAccountsCacheKeys,
  (props: PostAppsBusinessAccountsProps): Promise<AppsBusinessAccountsResult> => {
    return fetch("/apps/business/accounts", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
